import { render, staticRenderFns } from "./WorkorderLayoutComponent.vue?vue&type=template&id=3615bb59&scoped=true&"
import script from "./WorkorderLayoutComponent.vue?vue&type=script&lang=js&"
export * from "./WorkorderLayoutComponent.vue?vue&type=script&lang=js&"
import style0 from "./WorkorderLayoutComponent.vue?vue&type=style&index=0&id=3615bb59&prod&scoped=true&lang=css&"
import style1 from "./WorkorderLayoutComponent.vue?vue&type=style&index=1&id=3615bb59&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3615bb59",
  null
  
)

export default component.exports